/*
 * Sjöstrand cart — drawer and /cart page.
 * All handlers are delegated on document, so they keep working when the drawer markup is replaced
 * (by us, or by the theme's own getCart(), which swaps #cart.innerHTML with a fresh /cart render).
 * After every cart change we re-render the drawer via the Section Rendering API (sj-cart-drawer).
 */
(function () {
  'use strict';
  if (window.__sjCartDrawer) return;
  window.__sjCartDrawer = true;

  var SECTION = 'sj-cart-drawer';    // drawer markup
  var PAGE_SECTION = 'sj-cart-page'; // /cart page markup (same snippet, layout: 'page')
  var STORE_KEY = 'sjcd-dismissed';
  var GIFT_KEY = 'sjcd-gift-hidden'; // gift offers the customer closed (per product id, this browser)
  var CODE_KEY = 'sjcd-code'; // last code the customer entered here, per cart token (for display only)
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  // Roots: the drawer (#cart .sj-cd) and, on /cart, the page (.sj-cd--page). Both are refreshed after every change.
  function roots() { return $$('#cart .sj-cd, .sj-cd--page'); }
  function rootOf(el) { return el && el.closest ? el.closest('.sj-cd--page, #cart .sj-cd') : null; }
  function url(path) { return root.replace(/\/$/, '') + path; }

  function setBusy(on) {
    busy = on;
    roots().forEach(function (r) { r.classList.toggle('is-busy', on); });
  }

  function showError(message) {
    roots().forEach(function (r) {
      var box = $('.sj-cd__error', r);
      if (!box) return;
      box.textContent = message || r.getAttribute('data-sj-error-text') || 'Error';
      box.hidden = false;
    });
  }

  // fetch with a timeout, so a hanging request can never leave the drawer locked in its busy state
  function fetchT(input, init) {
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () { reject(new Error('timeout')); }, 12000);
      fetch(input, init).then(function (r) { clearTimeout(timer); resolve(r); }, function (e) { clearTimeout(timer); reject(e); });
    });
  }

  function postJSON(path, body) {
    return fetchT(url(path), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (json) {
        if (!res.ok) {
          var err = new Error((json && (json.description || json.message)) || 'Request failed');
          err.status = res.status;
          throw err;
        }
        return json;
      });
    });
  }

  function updateCount(count) {
    var n = parseInt(count, 10) || 0;
    $$('.js-cart-count').forEach(function (el) {
      el.innerHTML = n;
      el.classList.toggle('header-cart-trigger__count--items-in-cart', n > 0);
    });
  }

  function swap(current, html) {
    if (!current || !html) return null;
    var fresh = $('.sj-cd', new DOMParser().parseFromString(html, 'text/html'));
    if (!fresh) return null;
    var scroller = $('.sj-cd__scroll', current);
    var scrollTop = scroller ? scroller.scrollTop : 0;
    var expanded = !!$('.sj-cd__upsell-list.is-expanded', current);
    var node = document.importNode(fresh, true);
    current.parentNode.replaceChild(node, current);
    var next = $('.sj-cd__scroll', node);
    if (next) next.scrollTop = scrollTop;
    if (expanded) {
      var list = $('.sj-cd__upsell-list', node);
      var more = $('[data-sj-more]', node);
      if (list) list.classList.add('is-expanded');
      if (more) more.setAttribute('aria-expanded', 'true');
    }
    return node;
  }

  function refresh() {
    var drawerEl = $('#cart .sj-cd');
    var pageEl = $('.sj-cd--page');
    var wanted = [];
    if (drawerEl) wanted.push(SECTION);
    if (pageEl) wanted.push(PAGE_SECTION);
    if (!wanted.length) return Promise.resolve();
    return fetchT(url('/?sections=' + wanted.join(',')), { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var a = swap(drawerEl, data && data[SECTION]);
        var b = swap(pageEl, data && data[PAGE_SECTION]);
        var fresh = a || b;
        if (!fresh) throw new Error('Missing section');
        updateCount(fresh.getAttribute('data-item-count'));
        applyDismissed();
        showPendingCodes();
        document.dispatchEvent(new CustomEvent('sj:cart:updated', { detail: { itemCount: fresh.getAttribute('data-item-count') } }));
      });
  }

  function run(request) {
    if (busy) return;
    setBusy(true);
    request()
      .then(refresh)
      .catch(function (err) {
        return refresh().catch(function () {}).then(function () { showError(err && err.message); });
      })
      .then(function () { setBusy(false); });
  }

  // ---- Dismissed subscription offers (per variant, remembered in this browser) ----
  function readDismissed(key) {
    try { return JSON.parse(window.localStorage.getItem(key || STORE_KEY) || '[]'); } catch (e) { return []; }
  }
  function writeDismissed(list, key) {
    try { window.localStorage.setItem(key || STORE_KEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
  }
  function applyDismissed() {
    var list = readDismissed();
    $$('[data-sj-offer]').forEach(function (offer) {
      var v = offer.getAttribute('data-variant');
      var off = list.indexOf(v) !== -1;
      offer.classList.toggle('is-dismissed', off);
      var reopen = offer.parentNode && offer.parentNode.querySelector('[data-sj-undismiss][data-variant="' + v + '"]');
      if (reopen) reopen.hidden = !off;
    });
    // Gift offer closed with ×: hide the box, show the "Add your free gift" link instead.
    var gifts = readDismissed(GIFT_KEY);
    $$('[data-sj-gift-offer]').forEach(function (box) {
      var id = box.getAttribute('data-gift');
      var off = gifts.indexOf(id) !== -1;
      box.classList.toggle('is-dismissed', off);
      var reopen = box.parentNode && box.parentNode.querySelector('[data-sj-gift-undismiss][data-gift="' + id + '"]');
      if (reopen) reopen.hidden = !off;
    });
  }

  // ---- Entered discount code ----
  // A code saved with /cart/update.js is always carried to checkout, but Shopify does not always list it in
  // cart.discount_codes (e.g. when no item qualifies until checkout). Then we still show it under the link, so the
  // customer sees it was added. Remembered per cart token, so it never shows on a later, different cart.
  function readCode() {
    try { return JSON.parse(window.localStorage.getItem(CODE_KEY) || 'null'); } catch (e) { return null; }
  }
  function writeCode(val) {
    try {
      if (val) window.localStorage.setItem(CODE_KEY, JSON.stringify(val));
      else window.localStorage.removeItem(CODE_KEY);
    } catch (e) { /* private mode */ }
  }
  function cookieCode() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    try { return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; }
  }
  function pendingCode(wrap) {
    var saved = readCode();
    if (saved && saved.code && saved.token === wrap.getAttribute('data-cart-token')) return saved.code;
    return cookieCode();
  }
  function showPendingCodes() {
    $$('[data-codes]').forEach(function (wrap) {
      var known = (wrap.getAttribute('data-codes') || '').split(',').filter(Boolean);
      var code = known.length ? '' : pendingCode(wrap);
      var old = $('[data-sj-pending]', wrap);
      // Only touch the DOM when something changes (the drawer's MutationObserver calls this again).
      if (old && old.getAttribute('data-sj-pending') === code) return;
      if (old) old.parentNode.removeChild(old);
      if (!code) return;
      var row = document.createElement('p');
      row.className = 'sj-cd__code-status';
      row.setAttribute('data-sj-pending', code);
      var label = document.createElement('span');
      label.textContent = (wrap.getAttribute('data-added-text') || '%code%').replace('%code%', code);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sj-cd__link';
      btn.setAttribute('data-sj-code-remove', code);
      btn.textContent = wrap.getAttribute('data-remove-text') || '×';
      row.appendChild(label);
      row.appendChild(btn);
      wrap.insertBefore(row, wrap.firstChild);
    });
  }

  // ---- Click handling ----
  function closeDrawer() {
    var themeClose = $('#cart .modal__close');
    if (themeClose) themeClose.click();
  }
  function closeTips(except) {
    $$('.sj-cd__tip.is-open').forEach(function (tip) {
      if (tip === except) return;
      tip.classList.remove('is-open');
      var b = tip.querySelector('[data-sj-tip]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t || !t.closest('#cart, .sj-cd--page')) { closeTips(); return; }
    var el;
    var root = rootOf(t);

    // Click on the dimmed area outside the drawer panel closes the drawer.
    // (A click on #cart itself is already handled by the theme's own modal JS.)
    if (t.id !== 'cart' && t.closest('#cart') && isOpen() && !t.closest('.modal__dialog')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    if ((el = t.closest('[data-sj-tip]'))) {
      e.preventDefault();
      var tip = el.closest('.sj-cd__tip');
      closeTips(tip);
      var open = !tip.classList.contains('is-open');
      tip.classList.toggle('is-open', open);
      el.setAttribute('aria-expanded', String(open));
      return;
    }
    if (!t.closest('.sj-cd__tip')) closeTips();

    if ((el = t.closest('[data-sj-more]'))) {
      e.preventDefault();
      var list = root && $('.sj-cd__upsell-list', root);
      if (!list) return;
      var open = !list.classList.contains('is-expanded');
      list.classList.toggle('is-expanded', open);
      el.setAttribute('aria-expanded', String(open));
      return;
    }

    if ((el = t.closest('[data-sj-close]'))) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    if ((el = t.closest('[data-sj-qty]'))) {
      e.preventDefault();
      var next = (parseInt(el.getAttribute('data-qty'), 10) || 0) + (parseInt(el.getAttribute('data-sj-qty'), 10) || 0);
      var key = el.getAttribute('data-key');
      run(function () { return postJSON('/cart/change.js', { id: key, quantity: Math.max(0, next) }); });
      return;
    }

    if ((el = t.closest('[data-sj-remove]'))) {
      e.preventDefault();
      var rkey = el.getAttribute('data-key');
      run(function () { return postJSON('/cart/change.js', { id: rkey, quantity: 0 }); });
      return;
    }

    if ((el = t.closest('[data-sj-plan]'))) {
      e.preventDefault();
      if (el.classList.contains('is-current')) return;
      var planId = el.getAttribute('data-sj-plan');
      var body = {
        id: el.getAttribute('data-key'),
        quantity: parseInt(el.getAttribute('data-qty'), 10) || 1,
        selling_plan: planId ? parseInt(planId, 10) : null
      };
      run(function () { return postJSON('/cart/change.js', body); });
      return;
    }

    if ((el = t.closest('[data-sj-dismiss]'))) {
      e.preventDefault();
      var dv = el.getAttribute('data-variant');
      var list = readDismissed();
      if (list.indexOf(dv) === -1) list.push(dv);
      writeDismissed(list);
      applyDismissed();
      return;
    }

    if ((el = t.closest('[data-sj-gift-dismiss]'))) {
      e.preventDefault();
      var gid = el.getAttribute('data-gift');
      var hiddenGifts = readDismissed(GIFT_KEY);
      if (hiddenGifts.indexOf(gid) === -1) hiddenGifts.push(gid);
      writeDismissed(hiddenGifts, GIFT_KEY);
      applyDismissed();
      return;
    }

    if ((el = t.closest('[data-sj-gift-undismiss]'))) {
      e.preventDefault();
      var ugid = el.getAttribute('data-gift');
      writeDismissed(readDismissed(GIFT_KEY).filter(function (x) { return x !== ugid; }), GIFT_KEY);
      applyDismissed();
      return;
    }

    if ((el = t.closest('[data-sj-undismiss]'))) {
      e.preventDefault();
      var uv = el.getAttribute('data-variant');
      writeDismissed(readDismissed().filter(function (x) { return x !== uv; }));
      applyDismissed();
      return;
    }

    if ((el = t.closest('[data-sj-add]'))) {
      e.preventDefault();
      var variantId = parseInt(el.getAttribute('data-sj-add'), 10);
      run(function () { return postJSON('/cart/add.js', { items: [{ id: variantId, quantity: 1 }] }); });
      return;
    }

    if ((el = t.closest('[data-sj-code-toggle]'))) {
      e.preventDefault();
      var form = root && $('.sj-cd__code-form', root);
      if (!form) return;
      form.hidden = !form.hidden;
      el.setAttribute('aria-expanded', String(!form.hidden));
      if (!form.hidden) { var input = $('.sj-cd__input', form); if (input) input.focus(); }
      return;
    }

    if ((el = t.closest('[data-sj-code-apply]'))) {
      e.preventDefault();
      applyCode(root);
      return;
    }

    if ((el = t.closest('[data-sj-code-remove]'))) {
      e.preventDefault();
      var removeCode = el.getAttribute('data-sj-code-remove');
      var wrap = el.closest('[data-codes]');
      var codes = (wrap ? wrap.getAttribute('data-codes') : '').split(',').filter(function (c) { return c && c !== removeCode; });
      var saved = readCode();
      if (saved && saved.code === removeCode) writeCode(null);
      if (cookieCode() === removeCode) document.cookie = 'discount_code=; path=/; max-age=0';
      run(function () { return postJSON('/cart/update.js', { discount: codes.join(',') }); });
    }
  });

  function applyCode(root) {
    var input = root && $('.sj-cd__input', root);
    var code = input ? input.value.trim() : '';
    if (!code) { if (input) input.focus(); return; }
    var wrap = $('[data-codes]', root);
    var existing = (wrap ? wrap.getAttribute('data-codes') : '').split(',').filter(Boolean);
    if (existing.indexOf(code) === -1) existing.push(code);
    var token = wrap ? wrap.getAttribute('data-cart-token') : '';
    run(function () {
      return postJSON('/cart/update.js', { discount: existing.join(',') }).then(function (cart) {
        writeCode({ code: code, token: (cart && cart.token) || token });
        return cart;
      });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.classList && e.target.classList.contains('sj-cd__input')) {
      e.preventDefault();
      applyCode(rootOf(e.target));
      return;
    }
    if (e.key === 'Escape') {
      if ($('.sj-cd__tip.is-open')) { closeTips(); return; }
      if (isOpen()) closeDrawer();
    }
  });

  // Re-apply dismissed offers whenever the theme re-renders the drawer.
  function observe() {
    var modal = document.getElementById('cart');
    if (!modal || !window.MutationObserver) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () { pending = false; applyDismissed(); showPendingCodes(); });
    }).observe(modal, { childList: true, subtree: true });
  }

  // ---- Open state: the theme's modal JS sets .in on #cart while the drawer is open (all screen sizes) ----
  function isOpen() {
    var modal = document.getElementById('cart');
    return !!(modal && modal.classList.contains('in'));
  }

  // The drawer is a fixed full-screen overlay. In this theme <body> itself is the page wrapper (class "site-wrapper"),
  // and anything that turns body into a containing block (transform, filter, contain, will-change) makes "fixed" measure
  // against body instead of the screen: the overlay then stops short at the bottom when the page is scrolled. So #cart is
  // moved out of body, to the end of <html>, once. The theme finds it by id, so nothing else changes.
  function hoist() {
    var modal = document.getElementById('cart');
    var html = document.documentElement;
    if (modal && modal.parentNode !== html) html.appendChild(modal);
  }

  // Safety net for the overlay size: something in the theme or an app still makes the fixed overlay stop short at the
  // bottom on some pages. While the drawer is open, measure where #cart actually ends up and correct it so it covers
  // exactly the visible screen (offset, zoom and scaled wrappers included). Inline styles are removed again on close.
  function fit() {
    var modal = document.getElementById('cart');
    if (!modal) return;
    if (!modal.classList.contains('is-active')) {
      modal.style.removeProperty('top');
      modal.style.removeProperty('height');
      return;
    }
    var vh = window.innerHeight;
    modal.style.setProperty('top', '0px', 'important');
    modal.style.setProperty('height', vh + 'px', 'important');
    var r = modal.getBoundingClientRect();
    if (Math.abs(r.top) > 0.5) {
      modal.style.setProperty('top', (-r.top) + 'px', 'important');
      r = modal.getBoundingClientRect();
    }
    if (r.height > 0 && Math.abs(r.height - vh) > 0.5) {
      modal.style.setProperty('height', (vh * vh / r.height) + 'px', 'important');
    }
  }
  function watchFit() {
    var modal = document.getElementById('cart');
    if (!modal) return;
    var raf = 0;
    function schedule() {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = 0; fit(); });
    }
    if (window.MutationObserver) new MutationObserver(schedule).observe(modal, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', schedule);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule);
    fit();
  }

  // iOS: the theme locks page scrolling while the drawer is open by cancelling touchmove on the document and on its own
  // drawer wrapper (which does not scroll itself). That also blocked scrolling our inner list. Touch moves that start in
  // the drawer's scroll area are kept away from those handlers, so the list scrolls natively and the page stays locked.
  function allowInnerScroll() {
    var modal = document.getElementById('cart');
    if (!modal) return;
    modal.addEventListener('touchmove', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (t && t.closest('.sj-cd__scroll')) e.stopPropagation();
    }, { capture: true, passive: true });
  }

  function init() { hoist(); applyDismissed(); showPendingCodes(); observe(); watchFit(); allowInnerScroll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();
